import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';
import { FaUser, FaCog, FaSignOutAlt } from 'react-icons/fa';

const Navbar = () => {
  const { user, signOut } = useAuth();
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  
  const toggleProfileMenu = () => {
    setProfileMenuOpen(!profileMenuOpen);
  };
  
  return (
    <nav className="bg-primary-700 text-white shadow-md">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="text-xl font-bold flex items-center space-x-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
            <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
          </svg>
          <span>Album Planner</span>
        </Link>
        
        <div className="flex items-center space-x-6">
          <div className="flex space-x-4">
            <Link to="/" className="hover:text-primary-200 transition-colors">
              Dashboard
            </Link>
            <Link to="/moodboards" className="hover:text-primary-200 transition-colors">
              Moodboards
            </Link>
          </div>
          
          {/* User Profile Menu */}
          <div className="relative">
            <button 
              onClick={toggleProfileMenu}
              className="flex items-center space-x-2 focus:outline-none"
            >
              {user?.attributes?.picture ? (
                <img 
                  src={user.attributes.picture} 
                  alt="Profile" 
                  className="h-8 w-8 rounded-full object-cover border-2 border-white"
                />
              ) : (
                <div className="h-8 w-8 rounded-full bg-primary-500 flex items-center justify-center">
                  <FaUser className="text-white" />
                </div>
              )}
              <span className="hidden md:block">
                {user?.attributes?.name ? user.attributes.name.split(' ')[0] : 'User'}
              </span>
            </button>
            
            {profileMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 text-gray-800">
                <div className="px-4 py-2 border-b">
                  <p className="text-sm font-semibold">{user?.attributes?.name || 'User'}</p>
                  <p className="text-xs text-gray-500 truncate">{user?.attributes?.email || ''}</p>
                </div>
                <Link 
                  to="/settings" 
                  className="block px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
                  onClick={() => setProfileMenuOpen(false)}
                >
                  <FaCog className="mr-2" />
                  Settings & Export
                </Link>
                <button 
                  onClick={() => {
                    signOut();
                    setProfileMenuOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center text-red-600"
                >
                  <FaSignOutAlt className="mr-2" />
                  Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
